import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formMaxWidth } from '../constants/general-info-constants';
import GeneralInfoForm from '../shared-components/GeneralInfoForm';
import {
  getBiocharAndWaterSupplyEquipment,
  postBiocharAndWaterSupplyEquipment
} from '../../../../../../../actions/rof-burns/01-project-info/01-general-info';

const defaultFormState = {
  biocharEquipment: '',
  waterSupplyEquipment: '',
}

export default function BiocharAndWaterSupplyEquipment({ projectId, selectedCategory }) {
  const dispatch = useDispatch()
  const [formState, setFormState] = useState(defaultFormState)
  const [formErrors, setFormErrors] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const biocharAndWaterSupplyEquipmentData = useSelector((state) => (state.generalInfoReducer.biocharAndWaterSupplyEquipment?.data));

  useEffect(() => {
    handleFormErrorReset()
    dispatch(getBiocharAndWaterSupplyEquipment(projectId))
  }, [selectedCategory, projectId])

  useEffect(() => {
    if (biocharAndWaterSupplyEquipmentData)
      setFormState({
        biocharEquipment: biocharAndWaterSupplyEquipmentData?.biochar_equipment,
        waterSupplyEquipment: biocharAndWaterSupplyEquipmentData?.water_supply_equipment,
      })
    else {
      setFormState(defaultFormState)
    }

  }, [selectedCategory, projectId, biocharAndWaterSupplyEquipmentData])

  const biocharAndWaterSupplyEquipmentQuestions = (formState) => {
    const { biocharEquipment, waterSupplyEquipment } = formState
    return [
      {
        type: 'text',
        fieldId: 'biocharEquipment',
        text: 'Describe your biochar production equipment:',
        value: biocharEquipment,
        multiline: true,
        rows: 3,
        placeholder: 'Kilns, rakes, shovels, measurement tools, sundry tools.'
      },
      {
        type: 'text',
        fieldId: 'waterSupplyEquipment',
        text: 'Describe the fire-fighting equipment and water supply equipment that will be utilized during this project:',
        value: waterSupplyEquipment,
        multiline: true,
        rows: 3,
        placeholder: 'Describe water supply equipment (capacity, number of) - eg. Water tenders, backpack spray pumps, backup pumps, hose length, misting system, etc.'
      },
    ];
  }

  const onSubmit = async () => {
    try {
      setIsLoading(true)
      const submissionForm = { ...formState };

      await dispatch(postBiocharAndWaterSupplyEquipment(submissionForm, projectId))
      await dispatch(getBiocharAndWaterSupplyEquipment(projectId))
    } catch (error) {
      setFormErrors(error.message)
    } finally { setIsLoading(false) }
  }

  const setData = (event) => {
    const { name, type } = event.target;
    let value = event.target.value

    if (type === 'file') {
      value = event.target.files[0]
    }

    setFormState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  }

  const handleFormErrorReset = () => {
    setFormErrors(null);
  };

  const questions = biocharAndWaterSupplyEquipmentQuestions(formState)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: formMaxWidth }}>
      <Typography variant='h4' sx={{ pb: 2 }}>
        {selectedCategory}
      </Typography>
      <GeneralInfoForm
        formObjectArray={questions}
        formState={formState}
        formErrors={formErrors}
        isLoading={isLoading}
        onChange={setData}
        onSubmit={onSubmit} />
    </Box>
  )
}